import React from 'react';
import { PhotographerProvider } from '@context/PhotographerContext';
import { PhotographerEventsProvider } from '@context/PhotographerEventsContext';
import { PhotographerCustomersProvider } from '@context/PhotographerCustomersContext';
import { BillingProvider } from '@context/BillingContext';
import { PricingProvider } from '@context/PricingContext';
import PhotographerDashboard from './PhotographerDashboard';

const DashboardApp: React.FC = () => {
  return (
    <PhotographerProvider>
      <PhotographerEventsProvider>
        <PhotographerCustomersProvider>
          <BillingProvider>
            <PricingProvider>
              <PhotographerDashboard />
            </PricingProvider>
          </BillingProvider>
        </PhotographerCustomersProvider>
      </PhotographerEventsProvider>
    </PhotographerProvider>
  );
};

export default DashboardApp;
